<template>
    <section class='banner' :class="{ 'has-live' : streamingLive, 'streaming' : streaming }" :style="`background-image: url('${bannerImage}');`" >
        <div class="banner__embed" v-if="streamingLive && streaming" v-html="streamingLive.embed">

        </div>
        <div class='banner__content-wrapper' v-if="streamingLive">
            <h1 class='banner__title'>
                <div class="container p-0">
                    AO VIVO <br><span v-html="streamingLive.title"></span>
                </div>
            </h1>
            <p class="banner__description" v-if="!streaming">{{ streamingLive.description }}</p>
            <a href="javascript:void(0);" v-if="!streaming" @click="streaming = true" tag="button" class="button button--action text-uppercase" >
                {{ $root.t('Assistir ao vivo')}}
            </a>
            <img v-if='!streaming' :src="require(`@/assets/${ $root.t('images/live.png')}`)" class='banner__live' >

            <a href="javascript:void(0);" class="banner__return btn btn-outline" @click="streaming = false" v-else>{{ $root.t('Voltar') }}</a>

        </div>

        <div class='banner__content-wrapper' v-if="bannerHome && !streamingLive">
            <h1 class='banner__title'>
                <div class="container p-0">
                    {{ bannerHome.banner_overtitle }} <br><span v-html="bannerHome.banner_title"></span>
                </div>
            </h1>
            <p v-if="bannerHome.banner_subtitle" class="banner__description" v-html="bannerHome.banner_subtitle"></p>
            <a v-if="bannerHome.banner_button_url && bannerHome.banner_button_text" :href="bannerHome.banner_button_url" tag="button" class="button button--action text-uppercase" v-html="bannerHome.banner_button_text"></a>
        </div>


        <div class='banner__content-wrapper' v-if="!bannerHome && !streamingLive">
            <img v-if="theme == 'bradesco'" class="banner__theme-logo" :src="require( '@/assets/'+$root.t('images/logo-bradesco.png') )" />
            <img class="banner__logo" :src="require( '@/assets/'+$root.t('images/logo.png') )" />
            <!-- <h1 class='banner__title text-uppercase'><span>Treine em Casa</span></h1> -->
            <h4 class="banner__description" v-html="$root.t('Mantenha sua rotina fitness com as aulas oficiais da maior rede de academias da América Latina')"></h4>
            <!-- <router-link to="/" tag="button" class="button button--action text-uppercase" >
                {{ $root.t('Começar')}}
            </router-link> -->
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            streaming : false,
            bannerImage : ''
        }
    },
    watch : {
        bannerHome () {
            if(this.bannerHome && this.bannerHome.banner_mobile) {
                this.bannerImage = window.innerWidth > 768 ? this.bannerHome.banner_desktop : this.bannerHome.banner_mobile
            }
        },
        streamingLive () {
            if(this.streamingLive && this.streamingLive.thumbnail.file) {
                this.bannerImage = this.streamingLive.thumbnail.file
            }
        }
    },
    computed : {
        ...mapGetters([
            'streamingLive',
            'bannerHome',
            'theme'
        ])
    },
}
</script>

<style lang="scss" scoped>

    .banner {
        width: 100%;
        background: transparent;
        min-height: 546px;
        background-size: cover;
        display: flex;
        align-items: center;
        position: relative;

        &.streaming {
            align-items: flex-start;

            @media screen and (max-width: 768px) {
                min-height: calc(100vw / 1.77);

                .banner__title { display: none; }
            }

            .banner__content-wrapper {
                min-height: 90px;
                background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.3), transparent);
                max-width: 100%;

                .banner__title {
                    width: 100%;
                    font-size: 14px;
                    span { font-size: 38px; }
                }

                .container * { transform: scale(0.8); }
            }
        }

        &__logo {
            height: 130px;
            width: auto;
        }

        &__return {
            position: absolute;
            right: calc((100vw - 1240px ) / 2);

            @media screen and (max-width: 768px) {
                right: 10px;
                top: 10px;
                transform: scale(0.7);
                transform-origin: top right;
            }
        }

        &__title {
            font-size: 26px;
            color: #FFB612;

            span {
                color: white;
                font-size: 56px;
                line-height: 54px;
                max-width: 70%;
                display: block;
            }
        }

        &__embed {
            position: absolute;
            display: flex;
            justify-content: center;
            background-color: black;
            height: 100%;
            width: 100%;

            /deep/ iframe {
                width: 100vw;
                height: calc(100vw / 1.77);

                @media screen and (min-width: 1025px) {
                    width: calc(546px * 1.77);
                    height: 100%;
                }
            }
        }

        &__content-wrapper {
            display: flex;
            min-height: 546px;
            align-items: flex-start;
            justify-content: center;
            padding: 0 15px;
            margin: 0 auto;
            max-width: 1240px;
            width: 100%;
            flex-direction: column;
            position: relative;
        }

        &__description {
            font-weight: 300;
            font-size: 21px;
            line-height: 30px;
            max-width: 600px;
            margin: 0;
        }

        &__live {
            width: 140px;
            height: 51px;
            position: absolute;
            top: 15px;
            right: 15px;
        }

    }

    .button {
        margin: 20px 0 0;
        padding: 16px 24px;
        font-family: 'Rubik';
        font-size: 16px;
        font-weight: bold;

        &--action {
            background: #D52B1E;
            color: white;
            border: 0;
            border-radius: 4px;
        }

        &--learn-more {
            background: transparent;
            color: white;
            border: 1px solid #FFB612;
            border-radius: 4px;
        }
    }

</style>
